import styled from '@emotion/styled';

import { ReactComponent as Boom } from '@icons/pencil-paintings/boom.svg';
import { ReactComponent as DontGiveUp } from '@icons/pencil-paintings/dont-give-up.svg';
import { ReactComponent as ItsReallyRewarding } from '@icons/pencil-paintings/its-really-rewarding.svg';
import { ReactComponent as Rock } from '@icons/pencil-paintings/rock.svg';
import { ReactComponent as Smile } from '@icons/pencil-paintings/smile.svg';
import { ReactComponent as ThosePeopleWho } from '@icons/pencil-paintings/those-people-who.svg';

import { illustrationsBase } from '@styles/mixins/illustrations';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';

export const StyledBoom = styled(Boom)`
  ${illustrationsBase}
  left: -105px;
  bottom: 130px;

  ${getMediaqueryStyled('xl')} {
    display: none;
  }
`;

export const StyledItsReallyRewarding = styled(ItsReallyRewarding)`
  ${illustrationsBase}
  left: 345px;
  bottom: 100px;

  ${getMediaqueryStyled('xl')} {
    left: 250px;
    bottom: 190px;
    width: 181px;
  }

  ${getMediaqueryStyled('lg')} {
    display: none;
  }
`;

export const StyledThosePeopleWho = styled(ThosePeopleWho)`
  ${illustrationsBase}
  right: 570px;
  bottom: 60px;

  ${getMediaqueryStyled('xl')} {
    right: 575px;
    bottom: 30px;
    width: 402px;
  }

  ${getMediaqueryStyled('lg')} {
    left: 455px;
    bottom: 60px;
    width: 224px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledRock = styled(Rock)`
  ${illustrationsBase}
  right: 445px;
  bottom: 210px;

  ${getMediaqueryStyled('xl')} {
    right: 470px;
    bottom: 215px;
    width: 252px;
  }

  ${getMediaqueryStyled('lg')} {
    right: 285px;
    bottom: 165px;
    width: 141px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledDontGiveUp = styled(DontGiveUp)`
  ${illustrationsBase}
  right: calc(-1 * var(--side-field-size));
  bottom: 435px;

  ${getMediaqueryStyled('xl')} {
    bottom: 415px;
    width: 189px;
  }

  ${getMediaqueryStyled('lg')} {
    bottom: 260px;
    width: 146px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;

export const StyledSmile = styled(Smile)`
  ${illustrationsBase}
  right: calc(-1 * (var(--side-field-size) - 95px));
  bottom: 355px;

  ${getMediaqueryStyled('xl')} {
    right: calc(-1 * (var(--side-field-size) - 90px));
    bottom: 330px;
    width: 66px;
  }

  ${getMediaqueryStyled('lg')} {
    right: calc(-1 * (var(--side-field-size) - 55px));
    bottom: 215px;
    width: 51px;
  }

  ${getMediaqueryStyled('md')} {
    display: none;
  }
`;
